(function(){
  function initBoard(root){
    if(root.__boardInit) return; root.__boardInit = true;
    var track = root.querySelector('[data-board-track]');
    var prev = root.querySelector('[data-board-prev]');
    var next = root.querySelector('[data-board-next]');
    if(!track) return;
    function step(){ var c = track.querySelector('.care-board__card'); return c ? (c.offsetWidth + 24) : 346; }
    function upd(){ if(!prev || !next) return;
      prev.disabled = track.scrollLeft < 8;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 8;
    }
    if(next) next.addEventListener('click', function(){ track.scrollBy({ left: step(), behavior: 'smooth' }); setTimeout(upd, 450); });
    if(prev) prev.addEventListener('click', function(){ track.scrollBy({ left: -step(), behavior: 'smooth' }); setTimeout(upd, 450); });
    track.addEventListener('scroll', upd, { passive: true });
    window.addEventListener('resize', upd);
    upd();
  }
  function boot(){ document.querySelectorAll('.care-board').forEach(initBoard); }
  if(document.readyState !== 'loading') boot(); else document.addEventListener('DOMContentLoaded', boot);
})();
